import { Button, Checkbox } from "@material-ui/core";

export const Action = ({
  onClick,
  type = null,
  props = null,
  children = null,
  renderProp = null,
}) => {
  if (type === "button") {
    return (
      <Button onClick={onClick} {...props}>
        {children}
      </Button>
    );
  } else if (type === "icon") {
    return <img onClick={onClick} {...props} alt={"test"} />;
  } else if (type === "checkbox") {
    return (
      <Checkbox onClick={onClick} {...props}>
        {children}
      </Checkbox>
    );
  }

  return renderProp({ onClick });
};
